import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, Row, Col } from 'reactstrap';
import Draggable from 'react-draggable';

import { FetchData } from './utils/DataFetch';
import { GetCookie, RemoveCookie } from './utils/Common';

import Logo from '../images/logo1.png';

export class WorkOrderIntForm extends Component {
  static displayName = WorkOrderIntForm.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie('user'));
    this.state = {
      display_message: [],
      showButtons: true,
      showButtonSubmit: true,
      showCommentReason: false,
      deltaPosition: { x: 0, y: 0 },
      commentDeltaPosition: { x: 0, y: 0 },
    };

    //
    this.handleYesClick = this.handleYesClick.bind(this);
    this.handleNoClick = this.handleNoClick.bind(this);
    this.handleNoCommentClick = this.handleNoCommentClick.bind(this);
    //
    this.setShowCommentReason = this.setShowCommentReason.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.handleCommentDrag = this.handleCommentDrag.bind(this);
  }

  onStart = () => {};

  onStop = () => {};

  handleDrag(e, ui) {
    const { deltaPosition } = this.state;
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  }

  handleCommentDrag(e, ui) {
    const { commentDeltaPosition } = this.state;
    this.setState({
      commentDeltaPosition: {
        x: commentDeltaPosition.x + ui.deltaX,
        y: commentDeltaPosition.y + ui.deltaY,
      },
    });
  }

  componentDidMount() {
    var jobId = this.props.model.JobId;

    // If we have a valid jobId, fetch the interpreter confirmation data
    if (jobId != null) {
      // Show loading state if needed
      this.setState({ isLoading: true });

      FetchData(
        '/InterpreterConfirmationPageLoad/?jobId=' + jobId,
        'POST',
        this.user.token,
        {}
      )
        .then((data) => {
          if (data.message === 'Invalid') {
            RemoveCookie('user');
            window.location.reload();
          } else if (
            data.message &&
            data.message.includes(
              'This job has already been confirmed. Please Call 800-522-2320 for assistance.'
            )
          ) {
            // Close the modal if job has already been confirmed
            this.props.setModal(false);

            // Optional: You can show a notification/alert before closing
            this.props.handleSaveEventSuccess({
              message: data.message,
              modal: false,
              color: 'warning',
            });
          } else {
            this.setState({
              display_message: data.displayMessage,
              isLoading: false,
            });

            localStorage.removeItem('IsPageLoad');
          }
        })
        .catch((error) => {
          console.error('Error loading confirmation data:', error);
          this.setState({
            isLoading: false,
            display_message: ['Error loading job data. Please try again.'],
          });
        });
    } else {
      this.setState({
        display_message: ['Invalid Request. Job ID is missing.'],
      });
    }
  }

  handleYesClick() {
    var jobId = this.props.model.JobId;

    ////if (GetParameterByName('jobid') !== null) // when the page load with query string
    ////    jobId = GetParameterByName('jobid');
    ////else if (this.props.model != null) // when user double click
    ////    jobId = this.props.model.JobId;

    FetchData(
      '/FinalConfirmationYesButton/?q=' + jobId + '&userId=' + this.user.userid,
      'POST',
      this.user.token,
      {}
    ).then((data) => {
      var msg = [];
      msg.push(data);

      this.props.handleSaveEventSuccess({
        message: msg,
        modal: false,
        color: 'success',
      });

      //this.setState({
      //    display_message: msg,
      //    showButtons: false
      //});
    });
  }

  handleNoClick() {
    var jobId = this.props.model.JobId;

    FetchData(
      '/FinalConfirmationNoButton/?jobId=' + jobId + '&comment=NoButtonClick',
      'POST',
      this.user.token,
      {}
    ).then((data) => {
      console.log(data);
      var msg = [];
      msg.push(data.message);
      this.setState({
        display_message: msg,
        showButtons: false,
      });

      this.setShowCommentReason();
    });
    //}
  }

  handleNoCommentClick() {
    var jobId = this.props.model.JobId;

    FetchData(
      '/FinalConfirmationNoButtonCommentSubmit/?jobId=' +
        jobId +
        '&comment=' +
        this.commentText.value,
      'POST',
      this.user.token,
      {}
    ).then((data) => {
      //console.log(data);

      this.setShowCommentReason();

      this.props.handleSaveEventSuccess({
        message: data,
        modal: false,
        color: data === 'Success' ? 'success' : 'warning',
      });
    });
  }

  setShowCommentReason() {
    this.setState(
      {
        showCommentReason: !this.state.showCommentReason,
      },
      () => {}
    );
  }

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition, commentDeltaPosition } = this.state;
    const isMobile = window.innerWidth < 768;

    return (
      <div>
        <Draggable
          handle=".workorder-int-form-handle"
          onDrag={this.handleDrag}
          disabled={isMobile}
          {...dragHandlers}
        >
          <Modal
            isOpen={this.props.modal}
            toggle={this.props.setModal}
            style={{
              width: 'min(800px, 95vw)',
              transform: isMobile ? undefined : `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
            }}
          >
            <ModalHeader className="workorder-int-form-handle handle">
              Final Confirmation #{this.props.model.JobNum}
            </ModalHeader>
            <ModalBody>
              <div>
                <Row>
                  <Col>
                    <center>
                      <img src={Logo} alt="Logo" />
                    </center>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <center>
                      <br />
                      {this.state.display_message.map((str, i) => (
                        <p key={i}>
                          {str} <br />
                        </p>
                      ))}
                    </center>
                  </Col>
                </Row>
                {this.state.display_message !== '' && this.state.showButtons && (
                  <Row>
                    <Col>
                      <center>
                        <Button
                          color="success"
                          size="sm"
                          onClick={this.handleYesClick}
                          style={{
                            margin: '0 10px', // Add horizontal margin for spacing
                            minWidth: '100px', // Set minimum width
                            padding: '5px 10px', // Add more padding
                            fontSize: '1.1rem', // Slightly larger font
                          }}
                        >
                          Yes
                        </Button>{' '}
                        <Button
                          color="danger"
                          size="sm"
                          onClick={this.handleNoClick}
                          style={{
                            margin: '0 10px', // Add horizontal margin for spacing
                            minWidth: '100px', // Set minimum width
                            padding: '5px 10px', // Add more padding
                            fontSize: '1.1rem', // Slightly larger font
                          }}
                        >
                          No
                        </Button>
                      </center>
                    </Col>
                  </Row>
                )}
              </div>
            </ModalBody>
            {/*<ModalFooter>*/}

            {/*</ModalFooter>*/}
          </Modal>
        </Draggable>

        <Draggable
          handle=".workorder-int-form-comment-handle"
          onDrag={this.handleCommentDrag}
          disabled={isMobile}
          {...dragHandlers}
        >
          <Modal
            isOpen={this.state.showCommentReason}
            toggle={this.state.setShowCommentReason}
            style={{
              width: 'min(800px, 95vw)',
              transform: isMobile ? undefined : `translate(${commentDeltaPosition.x}px, ${commentDeltaPosition.y}px)`,
            }}
          >
            <ModalHeader className="workorder-int-form-comment-handle handle">
              Final Confirmation #{this.props.model.JobNum}
            </ModalHeader>
            <ModalBody>
              <div>
                <Row>
                  <Col>
                    <center>
                      <img src={Logo} alt="Logo" />
                    </center>
                  </Col>
                </Row>
                <Col>
                  <center>
                    <p>
                      <b>Cannot Cover Reason</b>
                    </p>
                  </center>
                </Col>
                <Row></Row>
                <Row>
                  <Col className="col-3"></Col>
                  <Col className="col-6">
                    <center>
                      <textarea
                        className="form-control"
                        cols={5}
                        ref={(input) => {
                          this.commentText = input;
                        }}
                      ></textarea>
                    </center>
                  </Col>
                  <Col className="col-3"></Col>
                </Row>
                {this.state.showButtonSubmit && (
                  <Row>
                    <Col>
                      <center>
                        <Button
                          color="danger"
                          size="sm"
                          onClick={this.handleNoCommentClick}
                          style={{
                            margin: '0 10px', // Add horizontal margin for spacing
                            minWidth: '100px', // Set minimum width
                            padding: '5px 10px', // Add more padding
                            fontSize: '1.1rem', // Slightly larger font
                          }}
                        >
                          Submit
                        </Button>
                      </center>
                    </Col>
                  </Row>
                )}
              </div>
            </ModalBody>
          </Modal>
        </Draggable>
      </div>
    );
  }
}
